import { useEffect, useState } from 'react'

import { getCachedPhoto, isLocalPhoto, resolvePhoto } from '@/lib/carwash/data/photo-store'

/**
 * Turns a saved photo reference into something an <img> can show.
 * Regular URLs come back straight away; photos taken on this device are
 * read from on-device storage after the first render.
 */
export const usePhotoUrl = (ref: string | null | undefined): string | null => {
    const [loaded, setLoaded] = useState<{ ref: string, url: string | null } | null>(null)
    const immediate = getCachedPhoto(ref)

    useEffect(() => {
        if (!ref || !isLocalPhoto(ref) || getCachedPhoto(ref)) return

        let active = true

        resolvePhoto(ref)
            .then(url => {
                if (active) setLoaded({ ref, url })
            })
            .catch(() => {
                if (active) setLoaded({ ref, url: null })
            })

        return () => {
            active = false
        }
    }, [ref])

    if (!ref) return null
    if (immediate) return immediate

    return loaded?.ref === ref ? loaded.url : null
}
